import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import SaveButton from '../common/savebutton';
import ObjectIdGenerator from '../modules/objectidgenerator';
import FilterProduct from '../domain/filterproduct';
import { saveProductRequest } from '../modules/productdata';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const styles = {
    textField: { ml: 1, mr: 1, width: '95%' },
    marginTop: { mt: '1em' },
};

export default function NewProductRequiredView(props) {
    const [saving, setSaving] = React.useState(false);
    const [name, setName] = React.useState('');
    const products = useSelector((state) => state.productdata.filterProducts);
    const [duplicate, setDuplicate] = React.useState(false);
    const [newlyCreatedProductId, setNewlyCreatedProductId] = React.useState(null);
    const dispatch = useDispatch();
    const selected = props.selected;
    const { t } = useTranslation();

    useEffect(() => {
        if (newlyCreatedProductId && products.find((p) => p.id === newlyCreatedProductId)) {
            setSaving(false);
            selected(
                newlyCreatedProductId,
                products.find((p) => p.id === newlyCreatedProductId)
            );
            setNewlyCreatedProductId(null);
        }
    }, [products, newlyCreatedProductId, selected]);

    const onChange = (e) => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value);
                break;
            default:
                break;
        }
        if (e.target.value && e.target.value.length > 3) {
            checkDuplicate(e.target.value);
        }
    };

    const checkDuplicate = (name) => {
        if (products.filter((p) => p.productName === name).length > 0) {
            setDuplicate(true);
        } else {
            setDuplicate(false);
        }
    };

    const onCancel = () => {
        props.cancel();
    };

    const onSave = async () => {
        setSaving(true);
        const id = await ObjectIdGenerator.newId();
        const prod = new FilterProduct();
        prod.productCode = '0';
        prod.id = id;
        prod.productName = name;
        prod.status = FilterProduct.StatusDraftRequest();
        await saveProductRequest(prod)(dispatch);
        setNewlyCreatedProductId(prod.id);
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                {t('product.giveNameForProductRequest')}{' '}
                {props.productRequestHint && props.productRequestHint.length > 0 && (
                    <span>
                        {t('product.youCanUseTheOriginalProductName')}:{' '}
                        <Button name="btn-product-hint" onClick={() => setName(props.productRequestHint)}>
                            {props.productRequestHint}
                        </Button>
                    </span>
                )}
            </Grid>
            {duplicate && (
                <Grid item xs={12}>
                    <Alert severity="error">{t('product.duplicateProductNameExists')}</Alert>
                </Grid>
            )}
            <Grid item xs={12}>
                <TextField
                    required
                    id="name"
                    name="name"
                    label={t('general.name')}
                    value={name}
                    sx={styles.textField}
                    margin="normal"
                    onChange={onChange}
                />
            </Grid>
            <Grid item xs={12}>
                <Grid container justifyContent="flex-end" spacing={1} sx={styles.marginTop}>
                    <Grid item>
                        <SaveButton
                            saving={saving}
                            disabled={saving || name.length < 3 || duplicate}
                            onSubmit={onSave}
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            name="cancel"
                            onClick={onCancel}
                            disabled={saving}
                            sx={{ bgcolor: 'grey.300', color: 'text.primary', '&:hover': { bgcolor: 'grey.400' } }}>
                            {t('buttons.cancel')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
